module.exports = __webpack_public_path__ + "static/img/10.03552f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slide/10.jpg
// module id = D3nu
// module chunks = 8